import React from 'react';
import Icon from '../Icon';

/*eslint-disable */
const Trash3 = (props) => (
  <Icon viewBox="0 0 13 15" {...props}>
    <g>
      <title>Page 1</title>
      <path d="M11 12a2 2 0 0 1-2 2H4a2 2 0 0 1-2-2V3h9v9zM5 1.5c0-.271.24-.5.525-.5h1.867c.301 0 .608.252.608.5V2H5v-.5zM9 2v-.5C9 .701 8.249 0 7.392 0H5.525C4.684 0 4 .673 4 1.5V2H0v1h1v9a3 3 0 0 0 3 3h5a3 3 0 0 0 3-3V3h1V2H9zm-1 9h1V5H8v6zm-2 0h1V5H6v6zm-2 0h1V5H4v6z"
        fill="currentColor" fillRule="evenodd" />
    </g>
  </Icon>
);
/*eslint-enable */

export default Trash3;



// WEBPACK FOOTER //
// ./~/wix-style-react/src/Icons/dist/components/Trash3.js